import axios from 'axios'
let pending=[];
//axios.defaults.baseURL = "http://localhost/baofu/";
axios.defaults.baseURL = "https://wx.ccvip.com.cn/api/";
//axios.defaults.baseURL = "https://wx-zhongguohuangjin.ccvip.com.cn/api/";
//axios.defaults.baseURL = "https://wx-laomiaohuangjin.ccvip.com.cn/api/";
//axios.defaults.baseURL = "https://wx-mingpaizhubao.ccvip.com.cn/api/";
axios.defaults.withCredentials = false
// axios.interceptors.request.use(config=>{
// 	config.cancelToken=new axios.CancelToken(cancel=>{
// 		pending.push({f:cancel})
// 	})
// 	return config
// })
axios.interceptors.response.use(res => {
	for(let p in pending){
		pending[p].f();	
		pending.splice(p,1)
	}
	res.cancelToken=new axios.CancelToken(cancel=>{
		pending.push({f:cancel})
	})

	return res.data;
});
export default {
	appid:'wxbf322cb490858105',
	oauth:axios.defaults.baseURL+'oauth/',
	path:axios.defaults.baseURL,
	dan:'http://www.ccvip.com.cn/router.aspx',
	req(v){

		v.data.pusern=localStorage.getItem('pusern');
		v.data.sys=localStorage.getItem('sys');
		return axios({
		
			method: "POST",
			headers: {
				'Content-Type': 'application/json'
			},
			responseType:v.responseType?v.responseType:'',
			url: v.url,
			onDownloadProgress:v.onDownloadProgress?v.onDownloadProgress:'',
			data: JSON.stringify(v.data)
		})
	},
	timestampToTime(timestamp) {
		var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
		var Y = date.getFullYear() + '-';
		var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
		var D = date.getDate() + ' ';
		var h = date.getHours() + ':';
		var m = date.getMinutes() + ':';
		var s = date.getSeconds();
		return Y+M+D+h+m+s;
	}
	
	
}

